import PaymentHelper from './payment';

const getAmortizations = (amount, termParam, aprParam, homeValue, additionalMonthlyExpenses, extraPaymentParam, includePmi, startDate, yearlyPaymentFrequency, cashBombValParam, cashBombFrequency, cashBombStartDate) => {
    let extraPayment = extraPaymentParam || 0;
    let cashBombVal = cashBombValParam;
    let term = termParam;
    const apr = aprParam;
    const monthArray = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const d = new Date(startDate);
    const cbStartDate = new Date(cashBombStartDate);
    const startYear = d.getFullYear();
    const amortizationsByYear = {};
    const newDate = new Date(d);
    let payment = PaymentHelper.getPayment(amount, term, apr);
    let balance = amount;
    let interest = 0.0;
    let principal = 0.0;
    let totalinterest = 0.0;
    let totalPayment = 0.0;
    let month = d.getMonth();
    let year = d.getFullYear();
    let counter = 0;
    let counterMonth;
    let daysGap;

    // Handle biweekly/weekly payments
    if (yearlyPaymentFrequency === 26) {
        payment = payment * 13 / yearlyPaymentFrequency;
        term = PaymentHelper.getTotalPayments(amount, yearlyPaymentFrequency, apr, payment);
    } else if (yearlyPaymentFrequency === 52) {
        payment = payment * 14 / yearlyPaymentFrequency;
        term = PaymentHelper.getTotalPayments(amount, yearlyPaymentFrequency, apr, payment);
    }

    for (let i = 1; i <= term; i++) {
        interest = balance * apr / (yearlyPaymentFrequency / 12);
        totalinterest += interest;
        if (payment + extraPayment > balance) {
            if (payment > balance) {
                extraPayment = 0;
                payment = balance;
            } else {
                extraPayment = balance - payment;
            }
        }
        principal = payment - interest;

        const oldBalance = balance;
        balance -= principal + extraPayment;
        if (i === Number(term) || balance < 1) {
            principal = oldBalance;
        }
        const prevBalance = balance + principal + extraPayment;
        if (balance - interest < 1) {
            if (extraPayment > 0) {
                extraPayment += balance;
            } else {
                principal = oldBalance;
            }
            balance = 0;
        }
        if (typeof amortizationsByYear[year] == 'undefined') {
            amortizationsByYear[year] = [];
            amortizationsByYear[year].monthsDetail = [];
        }
        let finalBalance = balance < 0 ? 0 : balance;
        const finalHomeValueForPMI = homeValue * 0.8;
        let pmi = (prevBalance < finalHomeValueForPMI ? 0 : amount * 0.625) / 100 / yearlyPaymentFrequency;
        if (parseInt(includePmi, 10)) {
            pmi = 0;
        }
        // eslint-disable-next-line eqeqeq
        if (yearlyPaymentFrequency == 12) {
            totalPayment += payment + pmi;
            let extra = extraPayment;
            // eslint-disable-next-line eqeqeq
            if (cashBombVal > 0 && finalBalance != 0) {
                // eslint-disable-next-line eqeqeq
                if (cbStartDate.getMonth() == month % 12 && cbStartDate.getFullYear() == year) {
                    if (balance > cashBombVal) {
                        balance -= cashBombVal;
                    } else {
                        cashBombVal = balance;
                        balance = 0;
                    }
                    finalBalance = finalBalance > cashBombVal ? finalBalance - cashBombVal : 0;
                    extra = extraPayment + cashBombVal;
                    if (cashBombFrequency > 1) {
                        cbStartDate.setMonth(cbStartDate.getMonth() + cashBombFrequency);
                    }
                }
            }
            amortizationsByYear[year].monthsDetail.push({
                monthYear: `${monthArray[month % 12]}/${year}`,
                namedMonth: monthArray[month % 12],
                month: month % 12,
                year,
                payment,
                extraPayment: extra,
                principal,
                interestPaid: interest,
                totalInterest: totalinterest,
                balance: finalBalance,
                otherExpenses: additionalMonthlyExpenses * 12 / yearlyPaymentFrequency + pmi,
                totalPayment,
            });
            if (month % 12 === 11) {
                year++;
            }
            month++;
        } else {
            let extra = extraPayment;
            counter++;
            counterMonth = newDate.getMonth();
            daysGap = Math.round(yearlyPaymentFrequency) === 26 ? 14 : 7;
            if (cbStartDate.getMonth() === counterMonth && newDate.getDate() === cbStartDate.getDate()) {
                if (balance > cashBombVal) {
                    balance -= cashBombVal;
                } else {
                    cashBombVal = balance;
                    balance = 0;
                }
                finalBalance = finalBalance > cashBombVal ? finalBalance - cashBombVal : 0;
                extra = extraPayment + cashBombVal;
                if (cashBombFrequency > 1) {
                    cbStartDate.setMonth(cbStartDate.getMonth() + cashBombFrequency);
                } else {
                    cashBombVal = 0;
                }
            }
            amortizationsByYear[year].monthsDetail.push({
                monthYear: `${newDate.getDate() + monthArray[counterMonth]}/${year}`,
                namedMonth: `${`0${newDate.getDate()}`.slice(-2)}-${monthArray[counterMonth].substring(0, 3)}`,
                month: counterMonth,
                year,
                payment,
                extraPayment: extra,
                principal,
                interestPaid: interest,
                totalInterest: totalinterest,
                balance: finalBalance,
                // eslint-disable-next-line eqeqeq
                otherExpenses: cashBombVal == 0 || cashBombFrequency == 12 || cashBombFrequency == 3
                    ? counter > yearlyPaymentFrequency
                        ? 0
                        : additionalMonthlyExpenses * 12 / yearlyPaymentFrequency + pmi
                    : counter >= yearlyPaymentFrequency
                        ? 0
                        : additionalMonthlyExpenses * 12 / yearlyPaymentFrequency + pmi,
            });
            if (cashBombVal > 0 && finalBalance !== 0) {
                const nextDate = new Date(newDate);
                nextDate.setDate(newDate.getDate() + daysGap);

                if (cbStartDate.getMonth() === counterMonth && cbStartDate.getFullYear() === year && nextDate.getTime() > cbStartDate.getTime() && nextDate.getDate() !== cbStartDate.getDate()) {
                    if (balance > cashBombVal) {
                        balance -= cashBombVal;
                    } else {
                        cashBombVal = balance;
                        balance = 0;
                    }
                    finalBalance = finalBalance > cashBombVal ? finalBalance - cashBombVal : 0;
                    amortizationsByYear[year].monthsDetail.push({
                        monthYear: `${cbStartDate.getDate() + monthArray[counterMonth]}/${year}`,
                        namedMonth: `${`0${cbStartDate.getDate()}`.slice(-2)}-${monthArray[cbStartDate.getMonth()].substring(0, 3)}`,
                        month: counterMonth,
                        year,
                        payment: 0,
                        extraPayment: cashBombVal,
                        principal: 0,
                        interestPaid: 0,
                        totalInterest: 0,
                        balance: finalBalance,
                        otherExpenses: 0,
                    });
                    counter++;
                    if (cashBombFrequency > 1) {
                        cbStartDate.setMonth(cbStartDate.getMonth() + cashBombFrequency);
                    } else {
                        cashBombVal = 0;
                    }
                }
            }
            if (month % 12 !== counterMonth) {
                month++;
            }
            // eslint-disable-next-line eqeqeq
            if (cashBombVal > 0 && counter > yearlyPaymentFrequency && (cashBombFrequency == 3 || cashBombFrequency == 12)) {
                counter = 0;
            }
            newDate.setDate(newDate.getDate() + daysGap);
            if (month % 12 === 11 && year !== newDate.getFullYear()) {
                year++;
                counter = 0;
            }
        }
        if (balance === 0) {
            break;
        }
    }
    const years = term / 12;
    let AllTotalPrincipal = 0;
    let AllTotalInterest = 0;
    let AllTotalTaxesFees = 0;
    let AllTotalExtraPayments = 0;
    for (let i = 0; i <= years; i++) {
        const y = startYear + i;
        if (amortizationsByYear[y]) {
            let TotalPrincipal = 0;
            let TotalInterest = 0;
            let TotalTaxesFees = 0;
            let TotalExtraPayments = 0;
            let TotalLoanBalance = 0;
            for (let j = 0; j < amortizationsByYear[y].monthsDetail.length; j++) {
                TotalPrincipal += amortizationsByYear[y].monthsDetail[j].principal;
                TotalInterest += amortizationsByYear[y].monthsDetail[j].interestPaid;
                TotalTaxesFees += amortizationsByYear[y].monthsDetail[j].otherExpenses;
                TotalExtraPayments += amortizationsByYear[y].monthsDetail[j].extraPayment;
                TotalLoanBalance = amortizationsByYear[y].monthsDetail[j].balance;
            }
            amortizationsByYear[y].totalPrincipal = TotalPrincipal;
            amortizationsByYear[y].totalInterest = TotalInterest;
            amortizationsByYear[y].totalTaxesFees = TotalTaxesFees;
            amortizationsByYear[y].totalExtraPayments = TotalExtraPayments;
            amortizationsByYear[y].totalLoanBalance = TotalLoanBalance;
            AllTotalPrincipal += TotalPrincipal;
            AllTotalInterest += TotalInterest;
            AllTotalTaxesFees += TotalTaxesFees;
            AllTotalExtraPayments += TotalExtraPayments;
        }
        AllTotalPrincipal = AllTotalPrincipal < 0 ? 0 : AllTotalPrincipal;
        AllTotalInterest = AllTotalInterest < 0 ? 0 : AllTotalInterest;
        AllTotalTaxesFees = AllTotalTaxesFees < 0 ? 0 : AllTotalTaxesFees;
        AllTotalExtraPayments = AllTotalExtraPayments < 0 ? 0 : AllTotalExtraPayments;
    }
    const amortizationsData = {
        amortizationsByYear,
        AllTotalPrincipal,
        AllTotalInterest,
        AllTotalTaxesFees,
        AllTotalExtraPayments,
    };
    return amortizationsData;
};

export default {
    amortizationBreakdown(LoanAmount, LoanTerm, InterestRate, HomeValue = 0, AdditionalMonthlyExpenses = 0, ExtraPayment = 0, IncludePmi = 0, StartDate = new Date(), YearlyPaymentFrequency = 12, CashBombVal = 0, CashBombFrequency = 1, CashBombStartDate = new Date()) {
        return getAmortizations(LoanAmount, PaymentHelper.convertLoanTermInMonths(LoanTerm), PaymentHelper.convertInterestRatePerMonths(InterestRate), HomeValue, AdditionalMonthlyExpenses, ExtraPayment, IncludePmi, StartDate, YearlyPaymentFrequency, CashBombVal, CashBombFrequency, CashBombStartDate);
    },
};
